import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontFamily: typography.fontFamily,
        baseCheckboxBorderRadius: 4,
        baseCheckboxWidth: 16,
        baseCheckboxHeight: 16,
        baseCheckboxPadding: 2,
        checkboxLabelMarginLeft: 6,
        checkboxLabelColor: semantic.text.stronger.neutral,
        checkboxLabelDisabledColor: semantic.state.disable,
        checkboxBorderColor: semantic.border.neutral,
        checkboxHoverBgColor: semantic.state.subtle.neutral.hover,
        checkboxPressBgColor: semantic.state.subtle.neutral.press,
        checkboxHoverBorderColor: semantic.border.neutral,
        checkboxActiveBorderColor: semantic.border.neutral,
        checkboxDisabledBgColor: semantic.state.subtle.disable,
        checkboxDisabledBorderColor: semantic.state.disable,
        checkboxFocusBoxShadow: `0 0 0 2px ${semantic.bg.default}, 0 0 0 4px ${semantic.fill.primary}`,
        checkboxCheckedBgColor: semantic.fill.global.primary,
        checkboxCheckedHoverBgColor: semantic.state.primary.hover,
        checkboxCheckedActiveBgColor: semantic.state.primary.press,
        checkboxCheckedDisabledBgColor: semantic.state.subtle.primary.disable,
        descriptionMarginTop: 4,
        descriptionColor: semantic.text.neutral,
        descriptionFontSize: typography.fontSize.body,
        descriptionFontWeight: typography.fontWeight.body,
        descriptionLineHeight: typography.lineHeight.body,
    };
}
